import { domainSignal } from "@/utils/domain-store";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { imageConfig } from "../../../../config/config";
import { getText } from "../../../../utils/util";
import "./index.css";

export default function PageLogin({
  doLogin,
  companyData,
  nologinmsg,
  loginmsg,
}) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const { t: translate } = useTranslation();
  const lan = localStorage.getItem("i18n");
  const appStatus = localStorage.getItem("appStatus");
  const [language, setLanguages] = useState(lan ? lan : "zh");
  const [passwordType, setPasswordType] = useState(true);
  const [loginData, setLoginData] = useState<any>({
    username: "",
    password: "",
  });
  return (
    <div className="min-h-screen bg-neutral-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-neutral-800 rounded-xl shadow-card p-6 animate-fade-in">
        {/* 顶部logo区域 */}
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center">
            <img
              src={imageConfig.baseImageUrl + companyData?.companyLogoName}
              className="h-10 object-contain"
              alt="Company Logo"
            />
          </div>
          <div
            className="p-2 bg-neutral-700 rounded-full cursor-pointer hover:bg-neutral-600 transition-colors"
            onClick={() => {
              navigate("/chatcenter");
            }}
          >
            <img src="/img/kf.png" className="w-5 h-5" alt="Customer Service" />
          </div>
        </div>

        {/* 表单区域 */}
        <div className="space-y-6">
          {/* 用户名输入 */}
          <div className="space-y-2">
            <div className="text-neutral-300 text-sm font-medium">
              {translate(getText("賬號"))}
            </div>
            <div className="relative">
              <input
                className="w-full bg-neutral-700 border border-neutral-600 rounded-lg py-3 px-4 text-white focus:outline-none focus:ring-2 focus:ring-primary transition-all"
                type="text"
                value={loginData.username}
                onChange={(e) => {
                  setLoginData({
                    ...loginData,
                    username: e.target.value,
                  });
                }}
                placeholder={translate(getText("請輸入賬號"))}
              />
            </div>
          </div>

          {/* 密码输入 */}
          <div className="space-y-2">
            <div className="text-neutral-300 text-sm font-medium">
              {translate(getText("密碼"))}
            </div>
            <div className="relative">
              <input
                type="password"
                className="w-full bg-neutral-700 border border-neutral-600 rounded-lg py-3 px-4 text-white focus:outline-none focus:ring-2 focus:ring-primary transition-all"
                value={loginData.password}
                onChange={(e) => {
                  setLoginData({
                    ...loginData,
                    password: e.target.value,
                  });
                }}
                placeholder={translate(getText("請輸入密碼"))}
              />
            </div>
          </div>

          {/* 忘记密码链接 */}
          <div className="flex justify-end">
            <div
              className="text-primary-light text-sm cursor-pointer hover:text-primary transition-colors"
              onClick={() => {
                navigate("/reloadPassword");
              }}
            >
              {translate(getText("忘記密碼?"))}
            </div>
          </div>

          {/* 错误消息显示 */}
          {loginmsg && (
            <div className="text-danger text-sm py-1">{loginmsg}</div>
          )}

          {/* 登录按钮 */}
          <button
            className="w-full bg-gradient-primary py-3 rounded-lg text-black font-medium hover:opacity-90 transition-opacity"
            onClick={() => {
              doLogin(loginData);
            }}
          >
            {translate(getText("登錄"))}
          </button>

          {/* 注册和下载链接 */}
          <div className="flex justify-between text-sm pt-2">
            <span
              className="text-primary-light cursor-pointer hover:text-primary transition-colors"
              onClick={() => {
                navigate("/register");
              }}
            >
              {translate(getText("立即註冊"))}
            </span>
            {domainSignal.value?.appStatus === 1 && (
              <span
                className="text-primary-light cursor-pointer hover:text-primary transition-colors"
                onClick={() => {
                  navigate("/download");
                }}
              >
                App{(lan == "zh" ? "" : " ") + translate(getText("下載"))}
              </span>
            )}
          </div>
        </div>

        {/* 底部导航链接 */}
        <div className="mt-8 pt-4 border-t border-neutral-700">
          <div className="flex justify-center gap-2 text-sm text-neutral-400">
            <div
              className="cursor-pointer hover:text-primary-light transition-colors"
              onClick={() => {
                navigate("/changeline");
              }}
            >
              {translate(getText("切換線路"))}
            </div>
            <div className="text-neutral-600">/</div>
            <div
              className="cursor-pointer hover:text-primary-light transition-colors"
              onClick={() => {
                navigate("/changelanguage");
              }}
            >
              {translate(getText("切換語言"))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
